import { useMemo } from "react";
import colors from "styles/colors";

import DesignIcon from "static/svg/templates-store/design_icon.svg";
import CRMIcon from "static/svg/templates-store/sales_and_crm_icon.svg";
import SoftwareIcon from "static/svg/templates-store/software_development_icon.svg";
import PMIcon from "static/svg/templates-store/project_management_icon.svg";
import HRIcon from "static/svg/templates-store/hr_icon.svg";
import MarketingIcon from "static/svg/templates-store/marketing_icon.svg";

import { FEATURED_CATEGORY_CLICKED } from "/constants/bigbrain-event-types";
import { trackEvent } from "/services/bigbrain-service";
import { getSolutionCategoryPageLink } from "template-store/services/solution-links-service";
import Categories from "template-store/constants/categories";
import { getCategoryId } from "template-store/services/solution-categories-service";
import TilesList from "@mondaydotcomorg/monday-ui-components/dist/TilesList";
import { componentStyles } from "./categories-tiles-component.scss";

const categoryIdToTileMapping = (category) => {
  const categoryId = getCategoryId(category);

  const tile = {
    [Categories.MARKETING]: {
      background: colors["brand-red"],
      iconRenderer: () => <MarketingIcon />
    },
    [Categories.PROJECT_MANAGEMENT]: {
      background: colors["brand-yellow"],
      iconRenderer: () => <PMIcon />
    },
    [Categories.CRM]: { background: colors["brand-green"], iconRenderer: () => <CRMIcon /> },
    [Categories.DESIGN]: {
      background: colors["brand-blue"],
      iconRenderer: () => <DesignIcon />
    },
    [Categories.SOFTWARE_DEVELOPMENT]: {
      background: colors["brand-purple"],
      iconRenderer: () => <SoftwareIcon />
    },
    [Categories.HR]: { background: colors["brand-turqoise"], iconRenderer: () => <HRIcon /> }
  }[categoryId];

  return {
    categoryId,
    ...category,
    ...tile,
    link: getSolutionCategoryPageLink(categoryId),
    onClick: () => trackEvent(FEATURED_CATEGORY_CLICKED, { kind: categoryId })
  };
};

const CategoriesTiles = ({ title, categories }) => {
  const categoriesTiles = useMemo(() => categories.map((category) => categoryIdToTileMapping(category)), [categories]);

  return (
    <div className="category-tiles-component">
      <TilesList tiles={categoriesTiles} title={title} />
      <style jsx>{componentStyles}</style>
    </div>
  );
};

export default CategoriesTiles;
